import { httpClient } from './'
export const _saleRecordQuery = (params) => {
  return httpClient.post(`salerecord/query/`,
    params).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`))
    }
  })
}
export const _getSummarySheet = (params) => {
  return httpClient.post(`summary/sheet/`,
    params).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.msg}`))
    }
  })
}
export const _salerecordGenerateSheet = params => {
  return httpClient.post(`salerecord/generate_sheet/`, params, {
    responseType: 'blob'
  }).then(res => {
    // if (res.data.state_code === -1) {
    //   return Promise.reject(new Error(`${res.data.error_msg}`))
    // } else {
    //   return Promise.resolve(res)
    // }
    return Promise.resolve(res)
  })
}
export const _salerecordDetailQuery = (params) => {
  return httpClient.post(`salerecord/detail/query/`,
    params).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`))
    }
  })
}
export const _salerecordAdd = (params, machine_id) => {
  return httpClient.post(`salerecord/add/`,
    params, {
      headers: {
        'machine-id': apiKey
      }
    }).then(res => {
    if (res.data.state_code === 0) {
      return Promise.resolve(res.data.data)
    } else {
      return Promise.reject(new Error(`${res.data.error_msg}`))
    }
  })
}
